import React from "react";
import "./Emblems.css";

/**
 * Emblems
 *
 * Code-built (SVG + CSS) emblems for the How It Works caption slots,
 * as an alternative to AI-generated raster images. These are flat,
 * scalable, instantly recolorable, and can carry their own motion —
 * tradeoffs an AI-rendered glass/3D image can't offer, in exchange for
 * not matching that elaborate frosted-glass rendering style.
 *
 * Add more named exports here as additional emblems get built out.
 */

export const LiveSignalEmblem = () => (
    <svg
        viewBox="0 0 100 100"
        className="emblem emblem-live-signal"
        role="img"
        aria-label="Live activity signal"
    >
        <circle className="emblem-ring" cx="50" cy="50" r="14" />
        <circle className="emblem-ring emblem-ring-delay-1" cx="50" cy="50" r="14" />
        <circle className="emblem-ring emblem-ring-delay-2" cx="50" cy="50" r="14" />
        <circle className="emblem-dot" cx="50" cy="50" r="8" />
    </svg>
);

export const GeofenceEmblem = () => (
    <svg
        viewBox="0 0 100 100"
        className="emblem emblem-geofence"
        role="img"
        aria-label="Geofenced clock-in"
    >
        <defs>
            <linearGradient id="geofencePinGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3478f6" />
                <stop offset="100%" stopColor="#f45fa0" />
            </linearGradient>
            <linearGradient id="geofenceRingGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#3478f6" />
                <stop offset="100%" stopColor="#f45fa0" />
            </linearGradient>
            <radialGradient id="geofenceShadowGradient" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#1d1d1f" stopOpacity="0.35" />
                <stop offset="100%" stopColor="#1d1d1f" stopOpacity="0" />
            </radialGradient>
        </defs>

        <g className="emblem-geofence-map">
            <line x1="-20" y1="-30" x2="120" y2="70" />
            <line x1="-20" y1="5" x2="120" y2="105" />
            <line x1="-20" y1="40" x2="120" y2="140" />
            <line x1="-20" y1="-65" x2="120" y2="35" />
            <line x1="-20" y1="70" x2="120" y2="-30" />
            <line x1="-20" y1="105" x2="120" y2="5" />
            <line x1="-20" y1="140" x2="120" y2="40" />
            <line x1="-20" y1="35" x2="120" y2="-65" />
            <line className="emblem-geofence-pathway" x1="10" y1="90" x2="90" y2="15" />
            <circle className="emblem-geofence-waypoint" cx="50" cy="52" r="2.5" />
        </g>

        <ellipse className="emblem-geofence-shadow" cx="50" cy="70" rx="14" ry="4" />

        <g className="emblem-geofence-pin">
                    <ellipse className="emblem-geofence-ring" cx="50" cy="69" rx="22" ry="8" />
                    <path d="M50 26 C40 26 32 34 32 44 C32 54 41 62 50 73 C59 62 68 54 68 44 C68 34 60 26 50 26 Z" />
                    <circle className="emblem-geofence-pin-hole" cx="50" cy="44" r="8" />
                </g>
            </svg>
        );

export const SchedulingEmblem = () => (
<svg
viewBox="0 0 100 100"
className="emblem emblem-scheduling"
role="img"
aria-label="Shift scheduling"
>
<rect className="emblem-scheduling-loop" x="32" y="12" width="6" height="12" rx="3" />
<rect className="emblem-scheduling-loop" x="62" y="12" width="6" height="12" rx="3" />

<rect className="emblem-scheduling-card" x="20" y="18" width="60" height="64" rx="8" />
<rect className="emblem-scheduling-header" x="20" y="18" width="60" height="16" rx="8" />

<g className="emblem-scheduling-page emblem-scheduling-page-a">
<rect className="emblem-scheduling-cell" x="24" y="38" width="14.5" height="18" rx="2" />
<rect
className="emblem-scheduling-cell emblem-scheduling-cell-highlight"
x="42.5"
y="38"
width="14.5"
height="18"
rx="2"
/>
<rect className="emblem-scheduling-cell" x="61" y="38" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="24" y="60" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="42.5" y="60" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="61" y="60" width="14.5" height="18" rx="2" />
</g>

<g className="emblem-scheduling-page emblem-scheduling-page-b">
<rect className="emblem-scheduling-cell" x="24" y="38" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="42.5" y="38" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="61" y="38" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="24" y="60" width="14.5" height="18" rx="2" />
<rect className="emblem-scheduling-cell" x="42.5" y="60" width="14.5" height="18" rx="2" />
<rect
            className="emblem-scheduling-cell emblem-scheduling-cell-highlight"
            x="61"
            y="60"
            width="14.5"
            height="18"
            rx="2"
        />
    </g>
</svg>
);

export const PayrollEmblem = () => (
<svg
viewBox="0 0 100 100"
className="emblem emblem-payroll"
role="img"
aria-label="Payroll automation"
>
<path className="emblem-payroll-fold" d="M70 14 L78 14 L78 22 Z" />
<rect className="emblem-payroll-sheet" x="22" y="14" width="56" height="72" rx="6" />

<circle className="emblem-payroll-badge" cx="50" cy="25" r="9" />
<text className="emblem-payroll-badge-symbol" x="50" y="29" textAnchor="middle">
    $
</text>

<rect className="emblem-payroll-label" x="28" y="38" width="14" height="5" rx="2" />
<rect className="emblem-payroll-value emblem-payroll-row-0" x="45" y="38" width="27" height="5" rx="2" />

<rect className="emblem-payroll-label" x="28" y="51" width="14" height="5" rx="2" />
<rect className="emblem-payroll-value emblem-payroll-row-1" x="45" y="51" width="27" height="5" rx="2" />

<rect className="emblem-payroll-label" x="28" y="64" width="14" height="5" rx="2" />
<rect className="emblem-payroll-value emblem-payroll-row-2" x="45" y="64" width="27" height="5" rx="2" />

<rect className="emblem-payroll-label" x="28" y="77" width="14" height="5" rx="2" />
        <rect className="emblem-payroll-value emblem-payroll-row-3" x="45" y="77" width="27" height="5" rx="2" />
    </svg>
);

export const DocumentHubEmblem = () => (
    <svg
        viewBox="0 0 100 100"
        className="emblem emblem-dochub"
        role="img"
        aria-label="Document hub"
    >
        <defs>
            <clipPath id="dochubLogoClip">
                <rect x="20" y="30" width="60" height="44" rx="6" />
            </clipPath>
            <symbol id="dochubLogoPdf" viewBox="0 0 16 20">
                <rect width="16" height="20" rx="2" className="emblem-dochub-logo-pdf" />
                <path d="M10 0 L16 0 L16 6 Z" className="emblem-dochub-logo-fold" />
                <text x="8" y="15" textAnchor="middle" className="emblem-dochub-logo-text">
                    PDF
                </text>
            </symbol>
            <symbol id="dochubLogoWord" viewBox="0 0 16 20">
                <rect width="16" height="20" rx="2" className="emblem-dochub-logo-word" />
                <path d="M10 0 L16 0 L16 6 Z" className="emblem-dochub-logo-fold" />
                <text x="8" y="15" textAnchor="middle" className="emblem-dochub-logo-text">
                    DOC
                </text>
            </symbol>
        </defs>

        <g className="emblem-dochub-closed">
            <rect className="emblem-dochub-closed-cover" x="18" y="28" width="48" height="48" rx="6" />
            <circle className="emblem-dochub-ring" cx="22" cy="38" r="2" />
            <circle className="emblem-dochub-ring" cx="22" cy="52" r="2" />
            <circle className="emblem-dochub-ring" cx="22" cy="66" r="2" />
        </g>

        <g className="emblem-dochub-open">
            <rect className="emblem-dochub-open-spread" x="18" y="28" width="64" height="48" rx="6" />
            <line className="emblem-dochub-open-fold" x1="50" y1="28" x2="50" y2="76" />

            <g className="emblem-dochub-logos" clipPath="url(#dochubLogoClip)">
                <use href="#dochubLogoPdf" x="-10" y="42" width="16" height="20" />
                <use href="#dochubLogoWord" x="10" y="42" width="16" height="20" />
                <use href="#dochubLogoPdf" x="30" y="42" width="16" height="20" />
                <use href="#dochubLogoWord" x="50" y="42" width="16" height="20" />
                <use href="#dochubLogoPdf" x="70" y="42" width="16" height="20" />
                <use href="#dochubLogoWord" x="90" y="42" width="16" height="20" />
                <use href="#dochubLogoPdf" x="110" y="42" width="16" height="20" />
                            </g>
                        </g>
                    </svg>
                );

                export const ApplicantTrackingEmblem = () => (
                    <svg
                        viewBox="0 0 100 100"
                        className="emblem emblem-inbox"
                        role="img"
                        aria-label="Applicant tracking"
                    >
                        <path className="emblem-inbox-tray" d="M20 55 H80 L72 82 H28 Z" />
                        <rect className="emblem-inbox-rim" x="18" y="52" width="64" height="6" rx="3" />

                        <g className="emblem-inbox-paper-drop">
                                    <g className="emblem-inbox-paper-squash">
                                        <rect className="emblem-inbox-paper" x="38" y="46" width="24" height="30" rx="2" />
                                        <line className="emblem-inbox-paper-line" x1="42" y1="54" x2="58" y2="54" />
                                        <line className="emblem-inbox-paper-line" x1="42" y1="60" x2="58" y2="60" />
                                        <line className="emblem-inbox-paper-line" x1="42" y1="66" x2="54" y2="66" />
                                    </g>
                                </g>
                            </svg>
                        );

                        export const SelfServiceEmblem = () => (
                            <svg
                                viewBox="0 0 100 100"
                                className="emblem emblem-selfservice"
                                role="img"
                                aria-label="Employee self-service"
                            >
                                <circle className="emblem-selfservice-face" cx="50" cy="50" r="32" />

                                <line className="emblem-selfservice-tick" x1="50" y1="19" x2="50" y2="24" />
                                <line className="emblem-selfservice-tick" x1="50" y1="76" x2="50" y2="81" />
                                <line className="emblem-selfservice-tick" x1="19" y1="50" x2="24" y2="50" />
                                <line className="emblem-selfservice-tick" x1="76" y1="50" x2="81" y2="50" />

                                <circle className="emblem-selfservice-progress" cx="50" cy="50" r="36" />

                                <line className="emblem-selfservice-hand" x1="50" y1="50" x2="50" y2="26" />
                                                                 <circle className="emblem-selfservice-pivot" cx="50" cy="50" r="2.5" />
                                                             </svg>
                                                         );

                                 export const ClientCareEmblem = () => (
                                     <svg
                                         viewBox="0 0 100 100"
                                         className="emblem emblem-clientcare"
                                         role="img"
                                         aria-label="Client and care management"
                                     >
                                         <path className="emblem-clientcare-house" d="M50 18 L82 44 V82 H18 V44 Z" />
                                         <rect className="emblem-clientcare-door" x="44" y="62" width="12" height="20" rx="2" />

                                         <g className="emblem-clientcare-heart">
                                             <path d="M50 58 C46 52 36 53 36 62 C36 70 50 78 50 78 C50 78 64 70 64 62 C64 53 54 52 50 58 Z" />
                                         </g>
                                     </svg>
                                 );